import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    latestAnnouncements: [],
    allAnnouncements: [],
    currentTab: 0
};

const actions = {
    currentAnnouncementTab({ commit }, { tab }) { 
        commit("updateField", {
            path: "currentTab",
            value: tab,
        })
    },
    async fetchLatestAnnouncements({ commit }) {
        await db.collection('/announcements/covid19/covid_announcements').limit(5).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var latestAnnouncements = [];
                snapshot.forEach(doc => {
                    latestAnnouncements.push(doc.data());
                });
                commit("updateField", {
                    path: "latestAnnouncements",
                    value: latestAnnouncements,
                })
            });
    },
    async fetchLatestAnnouncementsPA({ commit }) {
        await db.collection('/announcements/covid19/pandemic2').limit(5).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var latestAnnouncements = [];
                snapshot.forEach(doc => {
                    latestAnnouncements.push(doc.data());
                });
                commit("updateField", {
                    path: "latestAnnouncements",
                    value: latestAnnouncements,
                })
            });
    },
    async fetchAllAnnouncement({ commit }) {
        // order by date asc
        

        
        await db.collection('/announcements/covid19/covid_announcements').orderBy('date', 'asc').get().then(
            (snapshot) => {
                var allAnnouncements = [];
                snapshot.forEach(doc => {
                    allAnnouncements.push({
                        id: doc.id,
                        content: doc.data()
                    });
                });
                commit("updateField", {
                    path: "allAnnouncements",
                    value: allAnnouncements,
                })
            });
    },
    async addAnnouncement({ }, { payload }) {

        await db.collection('/announcements/covid19/covid_announcements').add({
            type: payload.announcement.type,
            date: payload.announcement.date,
            message_en: payload.announcement.body,
            message_ar: payload.announcement.body1,
            message_am: payload.announcement.body2,
            source: payload.announcement.source,
            reference: payload.announcement.reference
        });

    },

    async updateAnnouncement({ }, { payload, payloadId }) {

        // Use a reference path for verified/fake  Doc to edit specific one. 
        await db.collection('/announcements/covid19/covid_announcements').doc(payloadId).update({
            type: payload.announcement.type,
            date: payload.announcement.date,
            message_en: payload.announcement.body,
            message_ar: payload.announcement.body1,
            message_am: payload.announcement.body2,
            source: payload.announcement.source,
            reference: payload.announcement.reference
        });
    },
    async deleteAnnouncement({ }, { payloadId }) {

        // Use a reference path for verified/fake  Doc to DELETE specific one. 
        await db.collection('/announcements/covid19/covid_announcements').doc(payloadId).delete();
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
